import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';


import {Tabs3Level} from 'src/components/tabs-3-level';
import {ACCOUNT_TABS} from 'src/constants';

import {Tab} from '@pb/kit-component-tabs-v2';

import {CONFERENCE_SUB_TABS} from './constants';

type Props = {
    accountId: number,
    activeSubTab: string,
};

export const ConferenceTabs = ({accountId, activeSubTab}: Props) => {
    const navigate = useNavigate();

    const setActiveTab = useCallback((tab: string) => {
        navigate(`/profile/account/${accountId}/${ACCOUNT_TABS.CONFERENCE.name}/${tab}`);
    }, [accountId, navigate]);

    return (
        <Tabs3Level activeTab={activeSubTab} setActiveTab={setActiveTab}>
            <Tab value={CONFERENCE_SUB_TABS.DETAILS.name} {...CONFERENCE_SUB_TABS.DETAILS}/>
            <Tab value={CONFERENCE_SUB_TABS.ADVERTISEMENT.name} {...CONFERENCE_SUB_TABS.ADVERTISEMENT}/>
            <Tab value={CONFERENCE_SUB_TABS.CONTENT.name} {...CONFERENCE_SUB_TABS.CONTENT}/>
        </Tabs3Level>
    );
};
